export enum SupportedLocales {
	de = 'de',
	en = 'en',
	en_US = 'en-us',
	es_ES = 'es-es',
	es = 'es',
	fr = 'fr',
	it = 'it',
	ja = 'ja',
	nl = 'nl',
	pt_BR = 'pt-br',
}
